export default {
  getComboUuidEditing: state => state.comboUuidEditing,
  getComboAlreadyFetchEditing: state => state.comboAlreadyFetchEditing,
  getComboName: state => state.comboName,
  getComboCommercialName: state => state.comboCommercialName,
  getComboCategoriesOptions: state => state.comboCategoriesOptions,
  getComboCategorySelected: state => state.comboCategorySelected,
  getComboMovementsOptions: state => state.comboMovementsOptions,
  getComboMovementSelected: state => state.comboMovementSelected,
  getComboScore: state => state.comboScore,
  getComboPhysicalPerson: state => state.comboPhysicalPerson,
  getComboLegalPerson: state => state.comboLegalPerson,
  getComboActive: state => state.comboActive,
  getComboRecommended: state => state.comboRecommended,
  getComboShouldBeDisplayed: state => state.comboShouldBeDisplayed,
  getComboIcon: state => state.comboIcon,
  getComboIconPreview: state => state.comboIconPreview,
  getComboCreatedThrough: state => state.comboCreatedThrough,

  getComboPlanOptions: state => state.comboPlanOptions,
  getComboPlansSelecteds: state => state.comboPlansSelecteds,

  getComboCampaignOptions: state => state.comboCampaignOptions,
  getComboCampaignSelecteds: state => state.comboCampaignSelecteds,

  getComboCoverageOptions: state => state.comboCoverageOptions,

  getComboCoverageStateOptions: state => state.comboCoverageStateOptions,
  getComboCoverageStatesSelecteds: state => state.comboCoverageStatesSelecteds,

  getComboCoverageCityStateOptions: state =>
    state.comboCoverageCityStateOptions,
  getComboCoverageCityStateSelected: state =>
    state.comboCoverageCityStateSelected,
  getComboCoverageCityOptions: state => state.comboCoverageCityOptions,
  getComboCoverageCitySelecteds: state => state.comboCoverageCitySelecteds,

  getComboCoverageDddOptions: state => state.comboCoverageDddOptions,
  getComboCoverageDddSelecteds: state => state.comboCoverageDddsSelecteds,

  getComboAccessOptions: state => state.comboAccessOptions,

  getComboAccessChainOptions: state => state.comboAccessChainOptions,
  getComboAccessChainsSelecteds: state => state.comboAccessChainsSelecteds,

  getComboAccessPosOptions: state => state.comboAccessPosOptions,
  getComboAccessPosSelecteds: state => state.comboAccessPosSelecteds,

  getComboDiscountOptions: state => state.comboDiscountOptions,
  getComboDiscountTypes: state => state.comboDiscountTypes,

  getComboDiscountPaymentOptions: state => state.comboDiscountPaymentOptions,
  getComboDiscountPaymentSelecteds: state => state.comboDiscountPaymentSelecteds,

  getComboDiscountShippingOptions: state => state.comboDiscountShippingOptions,
  getComboDiscountShippingSelecteds: state => state.comboDiscountShippingSelecteds,
}
